@if (label.length > 0) {
  <div class="label">
    {{ label }}
    @if (toolTipMsg.length) {
      <fa-icon
        class="info"
        [icon]="faInfoCircle"
        [andorTooltip]="toolTipMsg"
        tooltipPosition="right"></fa-icon>
    }
    @if (errorMsg && !control.valid && control.touched) {
      <fa-icon
        class="error"
        [icon]="faTriangleExclamation"
        [andorTooltip]="errorMsg"
        tooltipPosition="right"
        tooltipVariant="error"></fa-icon>
    }
  </div>
}
<div class="input-wrapper {{ !showAction ? 'full' : '' }}">
  <div class="text">
    <input
      type="{{ type }}"
      autocomplete="{{ autocomplete }}"
      [attr.aria-label]="label || placeholder"
      [attr.aria-invalid]="control.touched && control.invalid"
      placeholder="{{ placeholder }}"
      class="{{ mode }}"
      [formControl]="control"
      (keydown.enter)="onEnterPressed($event)" />
  </div>
  <div class="action-wrapper">
    <button
      type="button"
      class="{{ !showAction ? '' : 'action' }}"
      [disabled]="!control.valid"
      (click)="onActionClicked()">
      @if (!actionSuccess) {
        <ng-content></ng-content>
      } @else {
        <fa-icon [icon]="faCheck"></fa-icon>
      }
    </button>
  </div>
</div>
